module.exports = "/assets/data/cdbd0b08596094068f176d5ae9fbfdb3-SA1.data.json";